import { useNavigate } from "react-router-dom";
import useFloorFinderData from "../hooks/useFloorMatcherData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SquareCheck } from "lucide-react";
import arrowleft from "../../../../assets/icons/Vector_left.svg";
import arrowright from "../../../../assets/icons/Vector_right.svg";
import SkeletonFloorFinder from "../components/SkeletonFloorFinder";
import FinderGrid from "../components/FinderGrid";
import FinderButton from "../components/FinderButton";
import StepperRight from "../components/StepperRight";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import "../styles/floorMatcher.css";
import { customBuildQueryString } from "../../../../utils/url.utils";

const FloorMatcherPage = () => {
  const navigate = useNavigate();
  const {
    currentStep,
    setCurrentStep,
    steps,
    selections,
    toggleOption,
    getNextStepData,
    isSelected,
    validateSelections,
    loading,
    error,
    handleBack,
  } = useFloorFinderData();

  const handleSeeResults = () => {
    if (!validateSelections()) {
      toast.error("Please make a selection in all steps before continuing.");
      return;
    }

    const filterReq = {};

    if (selections[0]?.length) {
      filterReq.room = selections[0].map(i => i.key).filter(Boolean);
    }

    if (selections[1]?.length) {
      filterReq.size_in_feet = selections[1].map(i => i.key_filter).filter(Boolean);
    }

    if (selections[2]?.length) {
      filterReq.color = selections[2].map(i => i.key_filter).filter(Boolean);
    }

    if (selections[3]?.length) {
      filterReq.pattern = selections[3].map(i => i.key_filter).filter(Boolean);
    }

    const queryString = customBuildQueryString(filterReq);
    navigate(`/floor-covering?${queryString}`);
  };

  if (loading) return <SkeletonFloorFinder steps={steps} />;
  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!steps?.length) return <div>No carpet finder data available.</div>;

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} style={{ marginTop: "60px", zIndex: 999999999 }}
      />

      <Breadcrumbs paths={[{ label: "Floor Matcher", to: "" }]} />

      <div className="finder-wrapper">
        <div className="finder-main">
          <h2 className="finder-title">{steps[currentStep]?.title}</h2>

          <FinderGrid
            steps={steps}
            currentStep={currentStep}
            isSelected={isSelected}
            toggleOption={toggleOption}
            SquareCheck={SquareCheck}
          />

          <FinderButton
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            steps={steps}
            selections={selections}
            getNextStepData={getNextStepData}
            handleSeeResults={handleSeeResults}
            arrowleft={arrowleft}
            arrowright={arrowright}
            toast={toast}
            handleBack={handleBack}
          />
        </div>
        <StepperRight steps={steps} currentStep={currentStep} />
      </div>
    </>
  );
};
export default FloorMatcherPage;